export const SET_APP_CONFIG = 'SET_APP_CONFIG';
export const SET_APP_CONFIG_UI_FLAGS = 'SET_APP_CONFIG_UI_FLAGS';
export const SET_CONVERSATION_ATTRIBUTES = 'SET_CONVERSATION_ATTRIBUTES';
export const UPDATE_CONVERSATION_ATTRIBUTES = 'UPDATE_CONVERSATION_ATTRIBUTES';
export const CLEAR_CONVERSATION_ATTRIBUTES = 'CLEAR_CONVERSATION_ATTRIBUTES';
export const SET_CONVERSATION_LOAD = 'SET_CONVERSATION_LOAD';
export const SET_HIVER_CONFIG = 'SET_HIVER_CONFIG';
export const UPDATE_HIVER_CONFIG = 'UPDATE_HIVER_CONFIG';
export const CLEAR_HIVER_CONFIG = 'CLEAR_HIVER_CONFIG';
export const SET_DOCUMENT_WIDTH = 'SET_DOCUMENT_WIDTH';
export const SET_WIDGET_LOCATION_URL = 'SET_WIDGET_LOCATION_URL';
export const SET_KB_DETAILS = 'SET_KB_DETAILS';
export const SET_KB_SEARCH_RESULTS = 'SET_KB_SEARCH_RESULTS'
export const SET_KB_UI_FLAGS = "SET_KB_UI_FLAGS";
export const SET_SELECTED_ARTICLE_DATA = "SET_SELECTED_ARTICLE_DATA";
